import type { PortEnv } from '../../port-contract';
import { slot, values, type Arr } from './access';
import { numericNextSpellCarriers, isSlowSpell, type NextSpellCarrierDeps } from './next_spell_numeric_carriers';
/** PHP: ft_sanguine_next_spell_mana_discount_carriers (includes/functions/janus/core/sanguine_cast_mana_delta.php:31) */
export function ftSanguineNextSpellManaDiscountCarriers(caster: Arr, ability: Arr | null = null, env: PortEnv<NextSpellCarrierDeps>): Arr {
    if (env.deps.janus_trigger_in_progress()) return [];
    if (ability !== null && isSlowSpell(ability, env)) return [];
    return numericNextSpellCarriers(caster, 'next_spell_mana_discount', 'discount', 1, env, false, false);
}
/** PHP: ft_sanguine_next_spell_mana_discount_total (includes/functions/janus/core/sanguine_cast_mana_delta.php:72) */
export function ftSanguineNextSpellManaDiscountTotal(caster: Arr, ability: Arr | null = null, env: PortEnv<NextSpellCarrierDeps>): number {
    let total = 0;
    for (const carrier of values(ftSanguineNextSpellManaDiscountCarriers(caster, ability, env))) total += Number(slot(carrier, 'discount'));
    return total;
}
